import { render, staticRenderFns } from "./addmodal.vue?vue&type=template&id=88352568"
import script from "./addmodal.vue?vue&type=script&lang=js"
export * from "./addmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88352568')) {
      api.createRecord('88352568', component.options)
    } else {
      api.reload('88352568', component.options)
    }
    module.hot.accept("./addmodal.vue?vue&type=template&id=88352568", function () {
      api.rerender('88352568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/homeManage/addmodal.vue"
export default component.exports